export default "__VITE_ASSET__b8c2abf2__"